<ngx-monaco-editor
  [options]="codeOptions"
  [(ngModel)]="model"
  (ngModelChange)="modelChange()"
  [ngModelOptions]="{ standalone: true }"
  [ngClass]="cssClass"
  [ngStyle]="cssStyle"
></ngx-monaco-editor>
